module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/dog-hiking-582.156926dd85c3342e.png"+" 582w",
        images: [{path: "https://static.sniffspot.com/packs/img/dog-hiking-582.156926dd85c3342e.png",width: 582,height: 400}],
        src: "https://static.sniffspot.com/packs/img/dog-hiking-582.156926dd85c3342e.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/dog-hiking-582.156926dd85c3342e.png"},
        
        width: 582,
        height: 400
      }